export const userConsumptionHistoryColumns = [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'type' },
  { label: 'Status', value: 'status' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas', value: 'fee_total' },
  { label: 'Empresa', value: 'company' },
  { label: 'Cartão', value: 'card' },
  { label: 'Un/Consumo Informado', value: 'current_equipment_usage' },
  { label: 'Autor', value: 'author' },
  { label: 'Data e hora', value: 'created_at' },
]
